import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

const PERMISSIONS = {
  administrator: ['dashboard', 'chatbot', 'sheets', 'tables', 'students', 'rubrics', 'scans', 'mistakes', 'rechecks', 'feedback', 'users', 'access', 'messages', 'requests', 'pipeline', 'evaluate', 'subjective', 'courses', 'plans-preparations', 'ocr', 'mcqs', 'board-results', 'fees', 'work-log'],
  examiner: ['dashboard', 'chatbot', 'sheets', 'tables', 'students', 'rubrics', 'scans', 'mistakes', 'rechecks', 'feedback', 'messages', 'requests', 'pipeline', 'evaluate', 'subjective', 'courses', 'plans-preparations', 'ocr', 'mcqs', 'board-results', 'work-log'],
  // plans-preparations: teachers use Plans & Prep for chapter upload / generate / print
  teacher: ['dashboard', 'chatbot', 'students', 'rubrics', 'scans', 'mistakes', 'rechecks', 'feedback', 'messages', 'subjective', 'plans-preparations', 'work-log'],
  management: ['dashboard', 'chatbot', 'scans', 'students', 'rubrics', 'messages', 'rechecks', 'feedback', 'subjective', 'mcqs', 'board-results', 'fees', 'work-log']
};

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Restore session from localStorage on mount
  useEffect(() => {
    const savedUser = localStorage.getItem("currentUser");
    if (savedUser) {
      try {
        const user = JSON.parse(savedUser);
        setIsAuthenticated(true);
        setCurrentUser(user);
      } catch (e) {
        localStorage.removeItem("currentUser");
      }
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (user) => {
    setIsAuthenticated(true);
    setCurrentUser(user);
    localStorage.setItem("currentUser", JSON.stringify(user));
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentUser(null);
    localStorage.removeItem("currentUser");
    localStorage.removeItem("authToken");
    localStorage.removeItem("activeTab");
    localStorage.removeItem("rubricSubTab");
  };

  const hasAccess = (page) => {
    const role = currentUser?.role;
    return PERMISSIONS[role]?.includes(page) || false;
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      currentUser,
      isLoading,
      handleLogin,
      handleLogout,
      hasAccess
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
